import { Button } from "react-bootstrap";
import { Candidate } from "../../../../model/candidate.model";
import { QuestionsSummaryModel } from "../../../../model/questions-summary.model";
import config from "../../../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SKILL_CANDIDATE_TOPIC from "../../../../assets/images/user-profile-star.png";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import "../job-question-detail.component.scss"
import { Divider } from "@mui/material";
import "./candidate-summary.component.scss";
import RESUME_PURPLE from "../../../../assets/images/resume-purple.png";
import { downloadResume, getResume, postForceRegenerateReport } from "../../../../services/api.service";
import apiConfig from "../../../../api.config";
import BLUR_RATING from "../../../../assets/images/blue-rating.png";
import { useEffect, useState } from "react";
import PremiumModal from "../../../../modal/premium.modal";
import AI_WHITE from "../../../../assets/images/ai-icon.png"
import useDeviceType from "../../../../utils/device-type.util";

interface CandidateProps {
    candidateProfile: Candidate;
    sectionList: any;
    updateSection(field): void;
    interviewModel: any;
    reportModel: any;
    hideActionButtons?: boolean;
}

const CandidateSummary: React.FC<CandidateProps> = ({ candidateProfile, sectionList, updateSection, interviewModel, reportModel, hideActionButtons = false }) => {
    const [candidate, setCandidate] = useState<Candidate>();
    const [isPremium, setIsPremium] = useState(false);
    const [isGeneratingLink, setIsGeneratingLink] = useState(false);
    const [isRegeneratingReport, setIsRegeneratingReport] = useState(false);
    const { isMobile, isTablet, isDesktop } = useDeviceType();

    useEffect(() => {
        if (candidateProfile) {
            setCandidate(candidateProfile);
        }
    }, [candidateProfile])

    const viewResume = () => {
        if (candidateProfile.resume) {
            console.log(candidateProfile.resume.key);
            getResume(candidateProfile.resume.key).then
                ((res: any) => {
                    if (res.resume_url) {
                        window.open(res.resume_url, "_blank");
                    }
                })
        }
    }

    const clickPremium = () => {
        setIsPremium(true);
    }

    const handleClosePremium = () => {
        setIsPremium(!isPremium)
    }

    const submitPremium = () => {

    }

    const handleViewFullReport = async () => {
        setIsGeneratingLink(true);
        try {
            // Create the public report URL using existing report_id
            const reportUrl = `${window.location.origin}/public-report/${reportModel.report_id}`;

            // Open in new tab
            window.open(reportUrl, '_blank');
        } catch (error) {
            console.error('Error generating report link:', error);
        } finally {
            setIsGeneratingLink(false);
        }
    }

    const handleRegenerateReport = async () => {
        if (!reportModel?.report_id) return;
        setIsRegeneratingReport(true);
        try {
            const response = await postForceRegenerateReport(reportModel.report_id, {
                force: true,
                send_email: true,
            });
            if (!response?.data?.is_success) {
                throw new Error(response?.data?.error || response?.data?.message || "Regenerate failed");
            }
            alert(response?.data?.message || "Force regenerate report สำเร็จ");
        } catch (error) {
            console.error("Error force regenerating report:", error);
            alert("Force regenerate report ไม่สำเร็จ");
        } finally {
            setIsRegeneratingReport(false);
        }
    };

    return (
        <>
            {
                candidate &&
                <>

                    <div className="d-flex flex-column">
                        {/* View Full Report Button */}
                        {
                            !hideActionButtons && reportModel && reportModel.interview_status == "COMPLETED" &&
                            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                <Button
                                    className="button-std button-pdf"
                                    onClick={handleViewFullReport}
                                    disabled={isGeneratingLink}
                                >
                                    <img src={AI_WHITE} className="icon" />
                                    <span className="text">
                                        {isGeneratingLink ? "Generating link..." : "View Full Report"}
                                    </span>
                                </Button>
                                {reportModel.report_id && (
                                    <Button
                                        className="button-std button-pdf"
                                        onClick={handleRegenerateReport}
                                        disabled={isRegeneratingReport}
                                    >
                                        <img src={AI_WHITE} className="icon" />
                                        <span className="text">
                                            {isRegeneratingReport ? "Regenerating..." : "Force Regenerate Report"}
                                        </span>
                                    </Button>
                                )}
                            </div>
                        }


                        <div className="topic-control">
                            <img src={SKILL_CANDIDATE_TOPIC} className="topic-icon"></img>
                            <span className="topic-name">สรุปประวัติผู้สมัคร จาก Resume : {candidate.firstname} {candidate.lastname}</span>
                            <div className="d-flex" style={isMobile ? { marginRight: "auto" } : { marginLeft: "auto" }}>
                                {
                                    candidate.interview_status == "COMPLETED" &&
                                    <img src={BLUR_RATING} className="icon-blur-rating" onClick={clickPremium}></img>
                                }

                                <FontAwesomeIcon icon={sectionList.summary ? faChevronUp : faChevronDown}
                                    onClick={() => updateSection("summary")}
                                    className="icon-chevron"></FontAwesomeIcon>
                            </div>

                        </div>
                        {
                            sectionList.summary &&
                            <div className="section-expand-control">
                                <div className="summary-resume-control">
                                    <img src={RESUME_PURPLE} className="icon"></img>
                                    <span className="text" onClick={viewResume}>Resume</span>
                                </div>
                                <div className="section-control">
                                    <span className="summary-value-desc-gray">{candidate.resume ? candidate.resume.summary : "-"}</span>
                                </div>
                                <div className="section-control">
                                    {candidate.resume && candidate.resume.skills && candidate.resume.skills.length > 0 &&
                                        <>
                                            <div className="topic-control">
                                                <span className="topic-name">ทักษะของผู้สมัคร จาก Resume : {candidate.firstname} {candidate.lastname}</span>
                                            </div>
                                            <div className="section-expand-control">
                                                <div className="summary-skill-item">
                                                    {
                                                        candidate.resume.skills.map((item, index) => {

                                                            return (
                                                                <div className="summary-skill">
                                                                    {item}
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    }

                                </div>
                            </div>
                        }
                    </div>

                </>
            }
            {
                isPremium && <PremiumModal isOpen={isPremium} onClose={handleClosePremium} onSubmit={submitPremium}></PremiumModal>
            }
        </>
    );
};

export default CandidateSummary;
